module.exports = __webpack_public_path__ + "img/finland-digestive-diseases-male.eaf91ecb.png";